<template>
  <div v-if="props.subcategories?.length" class="-mx-1 mt-6" :class="{ 'flex items-center justify-center': showIcons }">
    <ul
      class="items-center justify-center xs:max-w-none sm:max-w-none md:relative md:mx-auto md:flex md:max-w-none md:flex-wrap xl:max-w-none"
      :class="{
        'xs:grid xs:max-w-[480px] xs:grid-cols-2 xs:gap-2 sm:max-w-[600px] sm:grid-cols-3 sm:gap-2': props.subcategories.length >= 3 && !showIcons,
        'xs:relative xs:mx-auto xs:flex xs:max-w-[720px] xs:flex-wrap sm:relative sm:mx-auto sm:flex sm:max-w-none sm:flex-wrap md:max-w-[720px]': props.subcategories.length < 3,
        'lg:justify-center': props.subcategories.length <= 8,
        'xl:justify-center': props.subcategories.length > 8 && props.subcategories.length <= 10,
        'relative mx-auto flex flex-wrap sm:grid sm:max-w-[480px] sm:grid-cols-3 sm:gap-4': props.subcategories.length === 3 && showIcons,
        'relative mx-auto flex flex-wrap sm:grid sm:max-w-[480px] sm:grid-cols-4 sm:gap-4': props.subcategories.length >= 4 && showIcons,
        'grid max-w-[480px] grid-cols-2 gap-4': showIcons,
      }"
    >
      <li v-for="(item, subcategoryId) in props.subcategories" :key="`subcategory-link-${subcategoryId}`" class="group" :class="{ 'h-full lg:w-auto': !showIcons }">
        <NuxtLink v-slot="{ isExactActive }" :to="item.url" :title="item.title" class="block h-full" :class="{ 'px-3 sm:px-2': !showIcons }">
          <div class="rounded-3xl" :class="{ 'p-3': showIcons, 'bg-background-soft-active': isExactActive }">
            <img
              v-if="showIcons && item.tileImage"
              :src="item.tileImage"
              :alt="item.title"
              class="h-translate-y-0 group-hover:h-translate-y-1 m-auto size-16 text-icon-active transition-transform duration-500"
            />
            <div
              class="mt-1 flex size-full items-center justify-center rounded-3xl text-center group-hover:text-text-strong xs:text-lg xs:font-normal sm:text-base sm:font-medium"
              :class="{
                'border border-border-active px-4 py-3': !showIcons,
              }"
            >
              {{ item.title }}
            </div>
          </div>
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
interface HallSubCategory {
  title: string
  url: string
  tileImage: string | null
  rank: number
}

const props = withDefaults(
  defineProps<{
    subcategories?: HallSubCategory[] | null
  }>(),
  {
    subcategories: () => [],
  }
)

const showIcons = computed(() => {
  return props.subcategories?.every((item) => item.tileImage) || false
})

const breakpoints = [
  { size: 1632, columns: 11 },
  { size: 1512, columns: 10 },
  { size: 1440, columns: 9 },
  { size: 1200, columns: 8 },
  { size: 1000, columns: 6 },
  { size: 680, columns: 5 },
  { size: 440, columns: 4 },
  { size: 0, columns: 3 },
]

const columnCount = ref(8)

const updateColumnCount = () => {
  const newWidth = window.innerWidth

  const breakpoint = breakpoints.find((b) => newWidth > b.size)
  if (breakpoint) {
    columnCount.value = breakpoint.columns
  }
}

onMounted(() => {
  const throttledUpdateColumnCount = useThrottleFrame(updateColumnCount)
  useEventListener(window, 'resize', throttledUpdateColumnCount, { passive: true })
  throttledUpdateColumnCount()
})
</script>
